import { authRoles } from 'app/auth';
import FmStorageTable from 'app/admin/fileManager/table/FmStorageTable';
import FmStorageEditForm from 'app/admin/fileManager/editform/FmStorageEditForm';
import FmBrowserTable from 'app/admin/fileManager/table/FmBrowserTable';
import FmDirectoryEditForm from 'app/admin/fileManager/editform/FmDirectoryEditForm';
import FmFileEditForm from 'app/admin/fileManager/editform/FmFileEditForm';

export default [
	{
		path: '/fm-storage/edit/:id',
		component: FmStorageEditForm,
		auth: authRoles.admin
	},
	{
		path: '/fm-storage/:sessionNameParam?',
		component: FmStorageTable,
		auth: authRoles.admin
	},
	{
		path: '/fm-browser/dir/:directory/:storage/:id',
		component: FmDirectoryEditForm,
		auth: authRoles.admin
	},
	{
		path: '/fm-browser/edit/:directory/:storage/:id',
		component: FmFileEditForm,
		auth: authRoles.admin
	},
	{
		path: '/fm-browser/:directory/:storage/:sessionNameParam?',
		component: FmBrowserTable,
		auth: authRoles.admin
	}
];
